import { EventEmitter, OnInit } from '@angular/core';
import 'brace/theme/solarized_dark';
import { Subject } from 'rxjs/Subject';
var CodeBoxComponent = /** @class */ (function () {
    function CodeBoxComponent() {
        this.insertHtml = new Subject();
        this.codeChanged = new EventEmitter();
    }
    CodeBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.insertHtml.subscribe(function (html) {
            _this.editorInstance.insert(html);
        });
    };
    CodeBoxComponent.prototype.onChange = function (code) {
        this.codeChanged.next(code);
    };
    Object.defineProperty(CodeBoxComponent.prototype, "editorInstance", {
        get: function () {
            return this.editor.nativeElement.env.editor;
        },
        enumerable: true,
        configurable: true
    });
    return CodeBoxComponent;
}());
export { CodeBoxComponent };
